import fetch from 'auth/FetchInterceptor'

const BranchLookUpService = {}

BranchLookUpService.fetch = function () {
	return fetch({
		url: '/branches',
		method: 'get'
	})
}

BranchLookUpService.create = function (data) {
	return fetch({
		url: '/branches',
		method: 'post',
		data
	})
}

BranchLookUpService.update = function (data) {
	return fetch({
		url: '/branches/' + data.id,
		method: 'put',
		data
	})
}

BranchLookUpService.delete = function (id) {
	return fetch({
		url: '/branches/' + id,
		method: 'delete',
	})
}

export default BranchLookUpService;